import { settings } from '@/utility';

export default {
  config: settings.app,
  cmsConfig: {},
  platform: settings.platform,
  product: settings.product,
  translations: settings.app.translations,
  language: settings.app.language,
  game: {
    eventTime: {
      countdown: 155,
      race: 20,
      results: 20,
    },
    raceId: 0,
    currentStage: '', // offer, race or results
    countdownTime: 0,
    tournamentId: 0,
    videoId: null,
    raceStartTime: 0,
    offer: {},
    results: {},
    previousResults: [],
    stateMode: true,
  },
  ui: {
    isLoaderActive: true,
    showcaseLoop: settings.app.showcaseLoop,
    showcaseItemTime: 10,
    videosPath: settings.app.videosPath,
    bgVideo: settings.app.bgVideo,
    infoMessage: '',
  },
  socketConnected: false,
  dataMock: settings.app.dataMock,
  appMode: settings.app.mode,
  debugMode: settings.app.debug,
};
